<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- MODAL -->
  <div
    class="modal fade"
    id="enviar-proposta-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    @click.self="cancelModal"
    @keydown.esc="cancelModal"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" style="padding: 0; margin: 0">
            <h4 style="margin-left: 20px; margin-top: 6px">PROPOSTA DE PARCELAMENTO</h4>
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <!-- PRACA -->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="description">PRAÇA</label>

                      <select class="custom-select rounded-0" v-model="formData.praca" @change="alterarPraca">
                        <option :value="praca.value" v-for="praca in pracas" :key="praca.value">{{ praca.nome }}</option>
                      </select>

                      <span style="color: red" v-for="error in v$.praca.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- VALOR -->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        VALOR
                        <!--<span v-if="formData.valor_proposta_convertido">- R$ {{ toCurrency(formData.valor_proposta_convertido) }}</span> -->
                        <span style="float: right; color: blue" v-if="lote.lote_permitir_form_proposta_inferior == 0">
                          MÍNIMO R$ {{ toCurrency(formData.valor_minimo) }}
                        </span>
                      </label>
                      <input
                        class="form-control"
                        v-model="formData.valor"
                        pattern="[0-9][0-9.,]*[0-9]"
                        title="Valor válido"
                        @keyup="alterarValorProposta"
                        @blur="formatarValor"
                      />

                      <span style="color: red" v-for="error in v$.valor_proposta_convertido.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- ENTRADA -->
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        % DE ENTRADA
                        <span style="float: right; float: right; color: blue" v-if="lote.lote_permitir_form_proposta_inferior == 0">
                          MÍNIMO {{ this.formData.lote_pct_entrada }}%
                        </span>
                      </label>
                      <div class="input-group mb-3">
                        <input class="form-control" v-model="formData.perc_entrada_formatado" @keyup="calcularEntrada" @blur="formatarEntrada()" />

                        <div class="input-group-append">
                          <div class="input-group-text" id="div-lock" style="background-color: white; border-left: 0px solid #000000 !important">
                            <span id="lock" class="fas fa-percent"></span>
                          </div>
                        </div>
                      </div>

                      <span style="color: red" v-for="error in v$.perc_entrada.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- PARCELAS -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="description" style="width: 100%">
                        QTD PARCELAS
                        <span style="float: right">R$ {{ formData.valor_qtd_parcelas }}</span>
                      </label>
                      <select class="custom-select rounded-0" v-model="formData.qtd_parcelas" @change="calcularParcela">
                        <option v-for="parcela in parcelas" :key="parcela" :value="parcela">{{ parcela }}</option>
                      </select>

                      <span style="color: red" v-for="error in v$.qtd_parcelas.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </span>
                    </div>
                  </div>

                  <!-- INDICE -->
                  <!--
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="description">ÍNDICE DE CORREÇÃO</label>
                      <input class="form-control" v-model="formData.indice" disabled />

                    
                      <span style="color: red" v-for="error in v$.indice.$errors" :key="error.$uid">
                        {{ error.$message }}
                      </span>
                    
                    </div>
                  </div>
                  -->
                </div>

                <p v-if="lote.lote_permitir_form_proposta_inferior == 0">Sua proposta deve obedecer o valor mínimo em Edital.</p>
                <p>Pedimos a gentileza de assinar a proposta e nos devolver via e-mail antes do início do leilão.</p>
                <p style="text-transform: uppercase; color: red">
                  Lembrando que essa proposta não garante o seu lance, deve solicitar habilitação no leilão e confirmar seu lance no auditório online.
                </p>
                <span>Comissão: {{ toCurrency(lote.lote_comissao) }}%</span>
                <br />
                <span>ICMS: {{ toCurrency(lote.lote_icms) }}%</span>
                <br />
                <span>Taxa administrativa: R${{ toCurrency(leilao.leilao_taxa_administrativa) }}</span>
                <br />
              </div>

              <!--<div v-html="corpo_email"></div> -->

              <div class="card-footer">
                <button data-toggle="modal" class="btn btn-success" @click="validate">Enviar proposta</button>
                <button
                  style="margin-left: 15px"
                  id="fechar_enviar_proposta"
                  class="btn btn-danger"
                  type="button"
                  data-dismiss="modal"
                  @click="this.setEnviarProposta(false)"
                >
                  Fechar
                </button>
                <button
                  id="close_enviar_proposta"
                  hidden
                  style="margin-left: 15px"
                  data-toggle="modal"
                  data-target="#enviar-proposta-modal"
                  class="btn btn-danger"
                >
                  close_enviar_proposta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auxFormatarEmail from "../controller/auxFormatarEmail.js";
import sweetAlert from "../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import currencyController from "../controller/currencyController.js";

import useVueLidate from "@vuelidate/core";
import { required } from "../locales/i18n.js";
import { computed, reactive } from "vue";
import { helpers } from "@vuelidate/validators";

export default {
  props: ["user", "lote", "leilao", "setEnviarProposta", "propostaEnviada", "propostas"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatarEmail],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      tests: [],
      acao: "",
      titulo_btn: "",
      titulo_modal: "",
      selected_task: "",
      audios: [],
      textos: [],
      contatos: [],
      parcelas: [],
      pracas: [],
      praca_atual: [],
      proposta_formatada: {},
      corpo_email: "",
    };
  },

  setup() {
    const formData = reactive({
      nome_campanha: "",
      audio_id: "",
      texto_id: "",
      contato_id: "",
      praca: "",
      valor: "",
      lote_pct_entrada: "",
      perc_entrada: "",
      perc_entrada_formatado: "",
      valor_perc_entrada: "",
      qtd_parcelas: "",
      valor_qtd_parcelas: "",
      indice: "",
      data_leilao: "",
      valor_proposta_convertido: "",
      valor_minimo: "",
    });

    const rules = computed(() => {
      return {
        praca: { required },
        perc_entrada: {
          required,
          validarMaximo: helpers.withMessage(" O valor de entrada deve ser maior ou igual ao mínimo. ", validarEntradaMinimo),
          validarMinimo: helpers.withMessage(" O valor máximo de entrada é 90%.", validarEntradaMaximo),
        },
        qtd_parcelas: { required },
        data_leilao: { required },
        valor_proposta_convertido: {
          required,
          validarMinimo: helpers.withMessage(" O valor da proposta precisar ser maior ou igual ao mínimo.", validarMinimo),
          validarMaximo: helpers.withMessage(" O valor da proposta precisar ser menor que 9.999.999.999.", validarMaximo),
        },
      };
    });

    const validarMaximo = (valor) => {
      if (valor && valor > 9999999999) {
        return false;
      } else {
        return true;
      }
    };

    const validarMinimo = (valor) => {
      if (!valor || valor < formData.valor_minimo) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMinimo = (valor) => {
      if (!valor || valor < 0 || valor < formData.lote_pct_entrada) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMaximo = (valor) => {
      if (valor > 90) {
        return false;
      } else {
        return true;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Create test");
    console.log(this.leilao);
    console.log(this.user);

    this.isLogged(() => {
      let btn = document.getElementById("close_enviar_proposta");

      btn.click();

      //PRAÇA ATUAL
      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        this.praca_atual = 1;
      } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        this.praca_atual = 2;
      } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        this.praca_atual = 3;
      } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        this.praca_atual = 4;
      }

      this.formData.valor_minimo = this.getValorAtual(this.lote);

      //VALOR
      if (this.lote.lote_avaliacao > 0) {
        this.formData.valor_proposta_convertido = Number(this.toNumber(this.getValorAtual(this.lote)));
        this.formatarValor();
      }

      //ENTRADA
      this.formData.perc_entrada_formatado = this.toCurrency(this.lote.lote_pct_entrada);
      this.formData.perc_entrada = this.lote.lote_pct_entrada;
      this.formData.valor_perc_entrada = (this.lote.lote_pct_entrada * this.lote.lote_avaliacao) / 100;

      //ENTRADA MÍNIMA
      this.formData.lote_pct_entrada = this.lote.lote_pct_entrada;

      //PARCELAS

      for (let i = 0; i < this.lote.lote_max_parcelas; i++) {
        this.parcelas.push(i + 1);
      }

      this.formData.qtd_parcelas = this.lote.lote_max_parcelas;
      this.formData.valor_qtd_parcelas = this.toCurrency(this.formData.valor / this.formData.qtd_parcelas);

      this.formData.indice = this.lote.lote_indice_correcao;

      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_1_data;

        this.pracas.push({ nome: "1º praça", value: 1 });
      }
      if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_2_data;

        this.pracas.push({ nome: "2º praça", value: 2 });
      }
      if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_3_data;

        this.pracas.push({ nome: "3º praça", value: 3 });
      }
      if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        this.formData.data_leilao = this.leilao.leilao_4_data;

        this.pracas.push({ nome: "4º praça", value: 4 });
      }

      this.formData.praca = this.pracas[0].value;

      console.log("Praças");
      console.log(this.pracas);

      this.alterarValorProposta();
    });
  },

  methods: {
    getValorAtual(lote) {
      if (this.praca_atual == 1) {
        return lote.lote_valor_1;
      } else if (this.praca_atual == 2) {
        return lote.lote_valor_2;
      } else if (this.praca_atual == 3) {
        return lote.lote_valor_3;
      } else if (this.praca_atual == 4) {
        return lote.lote_valor_4;
      }
    },

    isLogged(callback) {
      let data = {
        lote_id: this.lote.id,
        leilao_id: this.leilao.id,
      };

      axios
        .post(`/user/proposta/check`, data)
        .then((response) => {
          if (response.data.success) {
            callback();
          } else {
            this.isLoading = false;
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
            this.setEnviarProposta(false, true);
          }
        })
        .catch((error) => {
          console.log(error);

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para enviar proposta de parcelamento em lote de leilão você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para enviar proposta de parcelamento em lote de leilão você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }

          this.setEnviarProposta(false, true);
        });
    },

    alterarPraca() {
      console.log("Praça alterada");

      console.log(this.lote);

      if (this.formData.praca == 1) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_1);
      } else if (this.formData.praca == 2) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_2);
      } else if (this.formData.praca == 3) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_3);
      } else if (this.formData.praca == 4) {
        this.formData.valor = this.toCurrency(this.lote.lote_valor_4);
      }

      this.praca_atual = this.formData.praca;

      console.log("Valor");
      console.log(this.formData.valor);
      console.log(this.formData.praca);

      this.alterarValorProposta();
      this.formatarValor();

      this.formData.valor_minimo = this.getValorAtual(this.lote);

      console.log("Mínimo atual");
      console.log(this.formData.valor_minimo);

      /*
      this.formData.valor = this.lote.lote_avaliacao;
      this.alterarValorProposta();

      //VALOR
      if (this.lote.lote_avaliacao > 0) {
        this.formData.valor_proposta_convertido = Number(this.toNumber(this.lote.lote_avaliacao));
        this.formatarValor();
      }
        */
    },

    alterarValorProposta() {
      this.formData.valor_proposta_convertido = Number(this.toNumber(this.formData.valor));

      this.calcularEntrada();
    },

    formatarValor() {
      if (this.formData.valor_proposta_convertido > 0) {
        this.formData.valor = this.toCurrency(this.formData.valor_proposta_convertido);
      }

      if (this.formData.valor_a_vista_convertido > 0) {
        this.formData.valor_a_vista = this.toCurrency(this.formData.valor_a_vista_convertido);
      }
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    calcularEntrada() {
      /*
      console.log(typeof this.formData.valor_proposta_convertido);
      console.log(this.formData.perc_entrada);
      console.log(this.formData.valor_proposta_convertido);
      console.log((this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100);
      */

      this.formData.perc_entrada = Number(this.toNumber(this.formData.perc_entrada_formatado));

      this.calcularParcela();
      this.formData.valor_perc_entrada = (this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100;
    },

    formatarEntrada() {
      this.formData.perc_entrada_formatado = this.toCurrency(this.formData.perc_entrada_formatado);
    },

    calcularParcela() {
      console.log("Calculando parcelas");

      let valor_entrada = (this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100;

      this.formData.valor_qtd_parcelas = this.toCurrency((this.formData.valor_proposta_convertido - valor_entrada) / this.formData.qtd_parcelas);
      console.log(this.formData.valor_qtd_parcelas);
    },

    cancelModal() {
      this.setEnviarProposta(false);
    },

    async validate() {
      const result = await this.v$.$validate();

      if (result) {
        this.store();
      } else {
        console.log(this.v$);
      }
    },

    store() {
      this.isLoading = true;

      this.corpo_email = this.formatarEmail();

      if (this.corpo_email) {
        let data = {
          praca: this.formData.praca,
          valor_bem: this.getValorAtual(this.lote),
          valor_proposta: Number(this.toNumber(this.formData.valor)),
          valor_entrada: this.formData.valor_perc_entrada,
          pct_entrada: this.formData.perc_entrada,
          tipo: "parcelamento",
          lote_id: this.lote.id,
          leilao_id: this.leilao.id,
          indice: this.lote.lote_indice_correcao,
          parcelas: this.formData.qtd_parcelas,
          data_leilao: this.formData.data_leilao,
          corpo_email: this.corpo_email,
        };

        console.log("Cadastrando Proposta");
        console.log(data);

        axios
          .post(`/proposta/store`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              this.showSuccessMessageWithButtonAndReload(
                "Proposta enviada com sucesso!",
                "Atenção! A presente proposta atende o Art. 895 do Código de Processo Civil e não garante o lance, é necessário efetuar o lance e/ou realizar a disputa de lances no auditório online. Caso haja lance à vista, o lance parcelado será automaticamente desabilitado (Art. 895, § 7º do CPC), o proponente também poderá efetuar lances à vista, caso seja o interesse."
              );

              this.setEnviarProposta();
            } else {
              this.isLoading = false;
              this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },

    formatarEmail() {
      try {
        this.corpo_email = false;

        this.proposta_formatada = {
          lote_titulo: this.lote.lote_titulo,
          lote_numero: this.lote.lote_numero,
          leilao_id: this.leilao.id,
        };

        if (this.lote.processo) {
          if (this.lote.processo.processo_vara) {
            this.proposta_formatada.processo_vara = this.lote.processo.processo_vara;
          } else {
            this.proposta_formatada.processo_vara = "";
          }

          if (this.lote.processo.cidade) {
            this.proposta_formatada.cidade_processo = this.lote.processo.cidade;
          } else {
            this.lote.processo.cidade = "";
          }

          if (this.lote.processo.estado) {
            this.proposta_formatada.estado_processo_sigla = this.lote.processo.estado.sigla;
          } else {
            this.proposta_formatada.estado_processo_sigla = "";
          }
        }

        let corpo =
          '<div style="color:black">' +
          "<p><b>DATA DA PROPOSTA: </b> " +
          this.formatDate(new Date()) +
          "<br/></p>" +
          "<p><b>AUTOS: </b> AUTOS <br/></p>" +
          "<p><b>VARA/CIDADE: </b> " +
          this.proposta_formatada.processo_vara +
          "<br/></p>" +
          "<p><b>DATA LEILÃO: </b> " +
          this.formatDate(this.formData.data_leilao) +
          "<br/></p>" +
          "<p><b>PRAÇA: </b> " +
          this.formData.praca +
          "º PRAÇA<br/></p>" +
          "<p><b>DESCRIÇÃO DO BEM: </b> " +
          this.formatarHTML(this.lote.lote_descricao) +
          "<br/></p>" +
          "<p><b>VALOR DO BEM EM LEILÃO: </b> R$" +
          this.toCurrency(this.lote.lote_avaliacao) +
          "<br/></p>" +
          "<p><b>VALOR DA PROPOSTA: </b> R$" +
          this.toCurrency(Number(this.toNumber(this.formData.valor))) +
          "<br/></p>" +
          "<p><b>% DE ENTRADA: </b> " +
          this.formatarComissao(this.formData.perc_entrada.toString()) +
          "% (R$" +
          this.toCurrency(this.formData.valor_perc_entrada) +
          ") <br/></p>" +
          "<p><b>QTD PARCELAS: </b> " +
          this.formData.qtd_parcelas +
          "x <br/></p>" +
          "<p><b>VALOR DA PARCELA: </b> R$" +
          this.calcularParcela2(this.formData.valor, this.formData.valor_perc_entrada, this.formData.qtd_parcelas) +
          "<br/></p>" +
          "<p><b>COMISSÃO DO LEILOEIRO: </b> " +
          this.formatarComissao(this.lote.lote_comissao) +
          "%" +
          "<br/></p>" +
          "<p><b>INDICE DE CORREÇÃO: </b> " +
          this.lote.lote_indice_correcao +
          "<br/></p>" +
          "<p><b>PROPONENTE: </b> " +
          this.getProponente() +
          "<br/></p>" +
          "<p><b>ENDEREÇO: </b> " +
          this.getEndereco() +
          "<br/></p>" +
          "<p><b>CONTATO: </b> " +
          (this.user.profile.telefone_fixo ? this.user.profile.telefone_fixo : "") +
          " - " +
          this.user.profile.telefone_celular +
          "<br/></p>" +
          "<p><b>E-MAIL: </b> " +
          this.user.email +
          "<br/></p>" +
          "</div>";

        corpo = this.formatarVariaveisEmail(corpo, this.lote.id, this.lote.leilao_id);

        return corpo;
      } catch (error) {
        console.log(error);

        return false;
      }
    },

    getEndereco() {
      let endereco =
        this.user.profile.endereco +
        " - " +
        this.user.profile.endereco_num +
        " - " +
        this.user.profile.endereco_bairro +
        " - CEP: " +
        this.user.profile.endereco_cep +
        " - " +
        this.user.profile.cidade.nome +
        "/" +
        this.user.profile.estado.nome;
      return endereco;
    },

    getProponente() {
      let proponente =
        this.user.profile.nome_completo +
        " - " +
        this.user.profile.profissao +
        " - " +
        this.getEstadoCivil() +
        " - CPF: " +
        this.user.profile.cpf +
        " - RG: " +
        this.user.profile.rg;
      return proponente;
    },

    getEstadoCivil() {
      let estado_civil = this.user.profile.estado_civil;

      if (estado_civil == "divorciado") {
        return "divorciado";
      }

      if (estado_civil == "separado_judicialmente") {
        return "Separado judicialmente";
      }

      if (estado_civil == "casado") {
        return "Casado";
      }

      if (estado_civil == "viuvo") {
        return "Viuvo";
      }

      if (estado_civil == "solteiro") {
        return "Solteiro";
      }
      if (estado_civil == "solteiro_com_uniao_estavel") {
        return "Solteiro com união estável";
      }
      if (estado_civil == "solteiro_sem_uniao_estavel") {
        return "Solteiro sem união estável";
      }
      if (estado_civil == "uniao_estavel") {
        return "União estável";
      }
    },

    calcularParcela2(valor_proposta, valor_entrada, parcelas) {
      valor_proposta = Number(this.toNumber(valor_proposta));

      console.log("Calculando");
      console.log(valor_proposta);
      console.log(valor_entrada);

      return this.toCurrency((valor_proposta - valor_entrada) / parcelas);
    },

    formatarHTML(valor) {
      if (typeof valor == "string" && valor.includes("</")) {
        console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = valor;
        valor = div.textContent || div.innerText || "";
      }
      console.log("Valor depois");
      console.log(valor);

      return valor;
    },

    formatarComissao(texto) {
      if (typeof texto == "number") {
        return texto + ",00";
      } else {
        if (texto) {
          return this.replaceAll(texto, ".", ",");
        } else {
          return texto;
        }
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
